import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CatHotelLandingPage from "./pages/CatHotelLandingPage";
import LiveCameraPage from "./pages/LiveCameraPage";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CatHotelLandingPage />} />
        <Route path="/live" element={<LiveCameraPage />} />
      </Routes>
    </Router>
  );
}
